export default __webpack_public_path__ + "static/media/id-billing-picturemark-l.72811f64.svg";